import { NewReminderForm } from 'app/models/dto/new-reminder.model';
import { Alert } from 'app/models/dto/alert.model';

export class GetRemindersToday {
  static readonly type = '[Reminder] GetRemindersToday';
  constructor() {}
}

export class GetAllReminders {
  static readonly type = '[Reminder] GetAllReminders';
  constructor() {}
}

export class CreateReminder {
  static readonly type = '[Reminder] CreateReminder';
  constructor(public newReminder: NewReminderForm) {}
}

export class DeleteReminder {
  static readonly type = '[Reminder] DeleteReminder';
  constructor(public reminderId: number) {}
}

export class DismissReminderAlert {
  static readonly type = '[Reminder] DismissReminderAlert';
  constructor(public alert: Alert) {}
}

export class ClearReminderAlerts {
  static readonly type = '[Reminder] ClearReminderAlerts';
  constructor() {}
}

export class CreateReminderAlert {
  static readonly type = '[Reminder] ClearReminderAlert';
  constructor(public alert: Alert) {}
}

export class UpdateReminder {
  static readonly type = '[Reminder] UpdateReminder';
  constructor(public reminderId: number, public updates: any) {}
}
